import * as React from 'react';

import { Box, Typography } from '@mui/material';

import { Offer } from '../../../graphql/API';
import useRequirement from './useRequirment';

type RequirementProps = {
  data: Offer;
};

const rowSx = {
  display: 'flex',
  alignItems: 'center',
  py: 1,
  borderBottom: '1px solid #E6E6E6',
} as const;

const Requirement: React.FC<RequirementProps> = ({ data }) => {
  const requirements = useRequirement(data);

  return (
    <Box>
      {requirements.map(({ Icon, label }, i) => (
        <Box key={`requirement-${i}`} sx={rowSx}>
          <Icon sx={{ mr: 2 }} />
          <Typography
            sx={{
              fontSize: '13px',
              color: '#111',
              fontWeight: 400,
              fontFamily: 'Poppins',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Requirement;
